import React, { Component } from 'react';
import { setCar, setCarEmp, setCurrentTab } from './../../../redux/actions/';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ListCarrinho from './../../../fragments/listCarrinho';
import Valid from './validarCarrinho';
import api from './../../../utilites/api'
import Carregando from '../../../fragments/carregando2';
import CheckIcon from '@material-ui/icons/Check';
import MenuItem from '@material-ui/core/MenuItem';
import { Modal } from 'react-bootstrap';
import './carrinho.scss'
// import 'bootstrap/dist/css/bootstrap.min.css';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


class Carrinho extends Component {
  state = {
    listaEnd: false,
    codEmpresa: 0,
    retirada: false,
    enderecoNome: '',
    enderedoEnd: '',
    enderedoNumero: '',
    enderecoValor: 0,
    enderecoBairro: '',
    enderecoId: 0,
    cupom: '',
    nf: 'Sim',
    obs: '',
    time: "",
    date: '',
    ativo: true,
    colorHeader: "#991e25",

    vlEntrega: '0',
    vlCupom: '0',
    vl: '0',

    pagamento: 'Escolha',
    isCupom: false,
    isLoading: false,
    idCliente: 0,
    userNome: '',
    userTelefone: '',
    isMoto: false,
    isAgend: false,
    isTroco: true,
    isFisc: false,
    vlTroco: '0',
    notaFiscal: '',
    qtdFidel: "9",
    descFidel: 10,
    fidel: 0,
    aplicFidelidade: false,
    vlMinimo: 1,
    open: false,
    end_id: 0,
    enderecosEmpresa: [],
    desativar_retirada: false,
    apenas_retirada: false

  }

  vl = 0;
  vlAdc = 0;
  aplica = true;

  async componentDidMount() {
    this.setState({ isLoading: true });
    
    const response5 = await api.post('ws/ListEmpresas.php');
    
    const response = await api.post('ws/get_parametros.php');

    this.setState({
      vlMinimo: response.data.valor_minimo,
      desativar_retirada: response.data.desativar_retirada
    });

    function jsonEscape(str) {
      return str.replace(/\n/g, "\\\\n").replace(/\r/g, "\\\\r").replace(/\t/g, "\\\\t");
    }

    if (response5.status == 200) {
      console.log(JSON.parse(jsonEscape(response5.data)))
      this.setState({ enderecosEmpresa: JSON.parse(jsonEscape(response5.data)) })
    }

    this.setState({
      idCliente: localStorage.getItem('@webApp/userid'),
      userNome: localStorage.getItem('@webApp/userid') + '-' + localStorage.getItem('@webApp/username'),
      userTelefone: localStorage.getItem('@webApp/usertelefone'), end_id: localStorage.getItem('@webApp/enderecoId')
    });

    if (localStorage.getItem('@webApp/enderecoId') !== null) {
      if (localStorage.getItem('@webApp/enderecoId') !== '0') {
        if (localStorage.getItem('@webApp/enderecoId') !== '') {
          if (localStorage.getItem('@webApp/enderecoId') !== 'null') {
            console.log('enderecoId: ', localStorage.getItem('@webApp/enderecoId'));
            this.setState({
              enderecoNome: localStorage.getItem('@webApp/enderecoNome'),
              enderedoEnd: localStorage.getItem('@webApp/enderecoEnd'),
              enderecoBairro: localStorage.getItem('@webApp/enderecoBairro'),
              enderecoValor: localStorage.getItem('@webApp/enderecoValor'),
              enderedoNumero: localStorage.getItem('@webApp/enderecoNumero'),
              end_id: localStorage.getItem('@webApp/enderecoId')
            });
            this.getServidor();
          } else {
            this.setState({ isLoading: false });
          }
        } else {
          this.setState({ isLoading: false });
        }
      } else {
        this.setState({ isLoading: false });
      }
    } else {
      this.setState({ isLoading: false });
    }

  }

  async getServidor() {

    this.props.carr.carrinho.map(i => (
      this.vl = 0
    ));

    this.props.carr.carrinho.map(i => (
      this.vl = parseFloat(this.vl) + parseFloat(i.preco)
    ));



    this.setState({ time: new Date().getHours() + ":" + new Date().getMinutes() })
    if (this.state.isLoading) {
      try {
        const data = new FormData();
        data.append('bairro', this.state.enderecoBairro);
        data.append('idCliente', this.state.idCliente);
        data.append('Cliente', this.state.userNome);
        data.append('idEndereco', this.state.end_id);
        console.log('resposta1: ', this.state.end_id)
        const response = await api.post('ws/getVlEntrega.php', data);
        const response3 = await api.post('ws/StatusServico.php');
        const response4 = await api.post('ws/getFidel.php', data);
        console.log('resposta2: ', response.data)
        if (response.status === 200) {
          if (response.status !== '[]') {
            this.setState({
              vlEntrega: response.data.valor,
              apenas_retirada: response.data.apenas_retirada,
              ativo: response3.data.Codigo === '5' ? true : false,
              fidel: response4.data.compras,
            });

            console.log('Aplica pontos: ', this.state.fidel)
            if (this.state.fidel === this.state.qtdFidel) {
              var x = (parseFloat(this.vl) * parseFloat(this.state.descFidel)) / 100
              this.setState({
                vlCupom: x,
                aplicFidelidade: true
              });
            }

          }

        } else {
          alert('Erro na comunicação com servidor! - 1', 'Atenção', false);
        }

      } catch (error) {
        console.log('eroo ', error);
        localStorage.setItem('@webApp/enderecoNome', null);
        localStorage.setItem('@webApp/enderecoEnd', null);
        localStorage.setItem('@webApp/enderecoBairro', null);
        localStorage.setItem('@webApp/enderecoNumero', null);
        localStorage.setItem('@webApp/enderecoId', null);
        this.setState({
          enderecoNome: '',
          enderedoEnd: '',
          enderecoBairro: '',
          enderecoValor: 0,
          enderedoNumero: '',
          end_id: 0,
          vlEntrega: '0',
          enderedoEnd: '',
          isLoading: false
        });
        // alert('Erro na comunicação com servidor! - 2', 'Atenção', false);
      }
    } else {
      localStorage.setItem('@webApp/enderecoNome', null);
      localStorage.setItem('@webApp/enderecoEnd', null);
      localStorage.setItem('@webApp/enderecoBairro', null);
      localStorage.setItem('@webApp/enderecoNumero', null);
      localStorage.setItem('@webApp/enderecoId', null);
      this.setState({
        enderecoNome: '',
        enderedoEnd: '',
        enderecoBairro: '',
        enderecoValor: 0,
        enderedoNumero: '',
        end_id: 0,
        vlEntrega: '0',
        enderedoEnd: '',
        isLoading: false
      });
    }
    this.setState({ isLoading: false });
  }

  handleChange2 = (event) => {
    this.setState({ pagamento: event.target.value });
  }

  handleEndereco = (empresa) => {
    this.setState({
      listaEnd: false, codEmpresa: empresa.id, retirada: true
      , enderecoNome: empresa.endereco.split(`\\r\\n`).map((e, i) => { if (i > 0) return ' ' + e; else { return e } }),
      enderedoEnd: empresa.nome,
      enderedoNumero: '0',
      enderecoValor: 0,
      enderecoBairro: '0 - local',
      vlEntrega: '0',
      end_id: "0"
    });
  }

  handleCupom = async () => {
    this.setState({ isLoading: true });
    try {
      const data = new FormData();
      data.append('titulo', this.state.cupom);

      const response = await api.post('ws/ValidCupom.php', data);
      console.log('resposta: ', response.data)
      if (response.status === 200) {
        if (response.data.Descricao !== 'Cupom invalido') {
          var x = (parseFloat(this.vl) * parseFloat(response.data.percent)) / 100
          this.setState({
            vlCupom: x,
            isCupom: true
          });
        } else {
          alert(response.data.Descricao, 'Atenção', false);
        }
      } else {
        alert('Erro na comunicação com  servidor!', 'Atenção', false);
      }

    } catch (error) {
      console.log('eroo ', error)
      alert('Erro na comunicação com servidor!', 'Atenção', false);
    }

    this.setState({ isLoading: false });

  }

  async handlleEnviarPedido() {
    this.setState({ isLoading: true });
    var teste = '';
    var order = {}
    var Capa = [];
    console.log("Hora ", this.state.time)

    if (Valid(this.state)) {
      try {
        Capa = [...Capa, {
          idCliente: this.state.idCliente || '0',
          cliente: this.state.userNome || 'Cliente',
          retirada: this.state.retirada ? 'true' : 'false',
          codEmpresa: this.state.codEmpresa || '1',
          endereco: (this.state.enderedoEnd || 'Endereço') + ', ' + (this.state.enderedoNumero || '0') + ', ' + (this.state.enderecoBairro || 'Centro'),
          telefone: this.state.userTelefone || '0000000000',
          troco: String(this.state.vlTroco || '0').replace(",", "."),
          valor: parseFloat((parseFloat(this.vl) + parseFloat(this.state.vlEntrega) + (this.state.pagamento === 'Cartao' ? parseFloat(this.vlAdc) : 0)) - parseFloat(this.state.vlCupom)).toFixed(2),
          pagamento: this.state.pagamento || 'Dinheiro', 
          entrega: String(this.state.vlEntrega || '0').replace(",", "."),
          id_endereco: this.state.end_id || '0',
          obs: (this.state.vlTroco !== "" ? " -- Troco para: € " + this.state.vlTroco : "") +
            (this.state.notaFiscal !== "" ? " -- NFe para: " + this.state.notaFiscal : "") +
            (this.state.obs || ''),
          bairro: this.state.enderecoBairro || 'Centro',
          cupom: this.state.vlCupom !== '0' ? this.state.cupom : '',
          aplicFidelidade: this.state.aplicFidelidade || false
        }];
        var Itens = [];

        var Temp = this.props.carr.carrinho;
        var Id_adc = '';
        for (var i = 0; i < Temp.length; i++) {
          var x = '';
          console.log('Processando item do carrinho:', i, this.props.carr.carrinho[i]);
          var Temp2 = this.props.carr.carrinho[i].motagem;
          Id_adc = '';

          // ===== INÍCIO DA CORREÇÃO =====
          // Verificamos se 'motagem' existe e é um array
          if (Temp2 && Array.isArray(Temp2)) {
            console.log('Grupos de montagem encontrados:', Temp2);
            for (var j = 0; j < Temp2.length; j++) {
              var nomeGrupo = this.props.carr.carrinho[i].motagem[j];
              console.log('Processando grupo:', nomeGrupo);
              
              x = x + '(' + nomeGrupo + ": ";

              // Verificamos se a propriedade correspondente (ex: 'Sabores') também existe
              if (this.props.carr.carrinho[i][nomeGrupo] && Array.isArray(this.props.carr.carrinho[i][nomeGrupo])) {
                console.log('Itens do grupo', nomeGrupo, ':', this.props.carr.carrinho[i][nomeGrupo]);
                for (var y = 0; y < this.props.carr.carrinho[i][nomeGrupo].length; y++) {
                  var item = this.props.carr.carrinho[i][nomeGrupo][y];
                  if (typeof item === 'string' && item.includes('@')) {
                    x = x + item.split("@")[1] + ', ';
                    Id_adc = Id_adc + item.split("@")[0] + ', ';
                  } else {
                    x = x + item + ', ';
                  }
                }
              } else {
                console.log('Grupo', nomeGrupo, 'não encontrado ou vazio');
              }
              x = x + ') ';
            }
          } else {
            console.log('Nenhum grupo de montagem encontrado para o item', i);
          }
          // ===== FIM DA CORREÇÃO =====

          console.log('String final de adicionais para o item', i, ':', x);

          Itens = [...Itens, {
            produto: (this.props.carr.carrinho[i].id || '0') + ' - ' + (this.props.carr.carrinho[i].nome || 'Produto'), 
            quantidade: this.props.carr.carrinho[i].quant || 1, 
            valor: parseFloat(this.props.carr.carrinho[i].preco || 0).toFixed(2),
            observacao: this.props.carr.carrinho[i].observacao || '', 
            adcionais: x || '', 
            id_adc: Id_adc || '', 
            id_prod: this.props.carr.carrinho[i].id || '0',
            adicional_cartao: (this.state.pagamento === 'Cartao' ? (this.props.carr.carrinho[i].adicional_cartao || 0) : 0)
          }]
        }        // console.log('Capa ', JSON.stringify(Capa))
        // console.log('Itens ', JSON.stringify(Itens))

        const data = new FormData();
        data.append('JSon', JSON.stringify(Capa));
        data.append('JSon2', JSON.stringify(Itens));
        
        console.log('=== DADOS ENVIADOS PARA O SERVIDOR ===');
        console.log('Capa (JSon):', JSON.stringify(Capa, null, 2));
        console.log('Itens (JSon2):', JSON.stringify(Itens, null, 2));
        console.log('========================================');
        
        const response = await api.post('ws/finalizar_pedido.php', data);
        console.log('=== RESPOSTA DO SERVIDOR ===');
        console.log('Status da resposta:', response.status);
        console.log('Headers da resposta:', response.headers);
        console.log('Dados da resposta:', response.data);
        console.log('Status Text:', response.statusText);
        console.log('============================');


        if (response.status === 200 && response.data.Codigo === '100') {
          console.log('Pedido ', response.data);
          var arr = [];

          const {
            setCarEmp
          } = this.props;

          setCarEmp(arr);

          alert('Pedido realizado com sucesso!', 'Atenção', false);

          this.props.history.push({
            pathname: '/'
          })
          const {
            setCurrentTab
          } = this.props;
          setCurrentTab(0);
        } else {
          alert('Erro na comunicação com servidor!- 5', 'Atenção', false);
        }
  
      } catch (error) {
        // === LOG DETALHADO DE ERRO ===
        console.log('=================================');
        console.log('🚨 ERRO NO ENVIO DO PEDIDO');
        console.log('=================================');
        console.log('Erro completo:', error);
        
        // Análise detalhada do tipo de erro
        if (error.response) {
          // Erro de resposta do servidor
          console.log('📡 ERRO DE RESPOSTA DO SERVIDOR:');
          console.log('   Status Code:', error.response.status);
          console.log('   Status Text:', error.response.statusText);
          console.log('   Response Data:', error.response.data);
          console.log('   Response Headers:', error.response.headers);
          
          // Log específico para erro 500 (erro interno do servidor)
          if (error.response.status === 500 && typeof error.response.data === 'string') {
            console.log('🔴 ERRO 500 - DETALHES DO SERVIDOR:');
            console.log(error.response.data);
          }
          
        } else if (error.request) {
          // Erro de requisição (sem resposta do servidor)
          console.log('🌐 ERRO DE CONEXÃO:');
          console.log('   Request:', error.request);
          console.log('   Possível problema de rede ou servidor offline');
          
        } else {
          // Erro de configuração
          console.log('⚙️ ERRO DE CONFIGURAÇÃO:');
          console.log('   Message:', error.message);
        }
        
        // Informações da requisição tentada
        console.log('📋 DETALHES DA REQUISIÇÃO:');
        console.log('   URL:', error.config?.url || 'URL não disponível');
        console.log('   Método:', error.config?.method || 'Método não disponível');
        console.log('   Timeout:', error.config?.timeout || 'Não definido');
        console.log('=================================');
        
        // Exibir alerta apropriado para o usuário
        this.handleErrorAlert(error);
      }
      
      this.setState({ isLoading: false });
      
    } else {
      // Validação falhou - forma de pagamento não selecionada
      alert('Por favor, escolha a forma de pagamento antes de continuar.', 'Atenção', false);
      this.setState({ isLoading: false });
    }
  }

  // Método para lidar com alertas de erro de forma organizada
  handleErrorAlert(error) {
    if (error.response) {
      // Erro de resposta do servidor
      const status = error.response.status;
      const message = error.response.data || 'Erro desconhecido';
      
      switch (status) {
        case 400:
          alert('Dados inválidos enviados. Verifique as informações do pedido.', 'Erro de Validação', false);
          break;
        case 401:
          alert('Sessão expirada. Faça login novamente.', 'Sessão Expirada', false);
          break;
        case 403:
          alert('Acesso negado. Verifique suas permissões.', 'Acesso Negado', false);
          break;
        case 404:
          alert('Serviço não encontrado. Contate o suporte.', 'Serviço Indisponível', false);
          break;
        case 500:
          alert('Erro interno do servidor. Tente novamente em alguns minutos.', 'Erro do Servidor', false);
          break;
        case 503:
          alert('Serviço temporariamente indisponível. Tente novamente mais tarde.', 'Serviço Indisponível', false);
          break;
        default:
          alert(`Erro no servidor (${status}): ${message}`, 'Erro do Servidor', false);
      }
      
    } else if (error.request) {
      // Erro de conexão
      alert('Não foi possível conectar com o servidor. Verifique sua conexão com a internet.', 'Erro de Conexão', false);
      
    } else {
      // Erro de configuração ou outro
      alert('Ocorreu um erro inesperado. Tente novamente.', 'Erro Inesperado', false);
    }
  }

  formatMoney(valor) {
    // Remove todos os caracteres não numéricos e converte para formato decimal
    const valorNumerico = valor.replace(/\D/g, '');
    const valorDecimal = (valorNumerico / 100).toFixed(2);
    
    // Separa a parte inteira da decimal
    const partes = valorDecimal.split('.');
    const parteInteira = partes[0];
    const parteDecimal = partes[1];
    
    // Adiciona pontos como separadores de milhares
    const grupos = parteInteira
      .split('')
      .reverse()
      .join('')
      .match(/.{1,3}/g);
    
    // Reconstrói a parte inteira com pontos
    const gruposFormatados = grupos.map(grupo => 
      grupo.split('').reverse().join('') + '.'
    );
    
    const parteInteiraFormatada = gruposFormatados
      .reverse()
      .join('')
      .slice(0, -1); // Remove o último ponto
    
    // Retorna no formato brasileiro: 1.234,56
    return `${parteInteiraFormatada},${parteDecimal}`;
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  // Método para lidar com mudanças de campos que precisam de formatação monetária
  handleMoneyChange = e => {
    this.setState({ [e.target.name]: this.formatMoney(e.target.value) });
  };

  retornaAdc(i) {
    const carrinho = (this.props.carr && Array.isArray(this.props.carr.carrinho)) ? this.props.carr.carrinho : [];
    const item = carrinho[i];

    console.log('retornaAdc - Item do carrinho:', item);

    // Se o item não existe ou não tem a propriedade 'motagem', não faz nada.
    if (!item || !Array.isArray(item.motagem)) {
      console.log('Nenhuma montagem encontrada para o item:', item);
      return '';
    }

    console.log('Grupos de montagem encontrados:', item.motagem);

    // Processa cada grupo de personalização listado em 'motagem'
    const descricoes = item.motagem.map(nomeDoGrupo => {
      console.log(`Processando grupo: ${nomeDoGrupo}, valor:`, item[nomeDoGrupo]);
      
      // Verifica se o item do carrinho possui uma propriedade com este nome (ex: item['Borda'])
      if (item[nomeDoGrupo] && Array.isArray(item[nomeDoGrupo]) && item[nomeDoGrupo].length > 0) {
        
        const nomesDosItens = item[nomeDoGrupo].map(adicional => {
          if (typeof adicional === 'string' && adicional.includes('@')) {
            return adicional.split("@")[1];
          }
          return adicional;
        });

        // Retorna a descrição formatada. Ex: (Borda: CATUPIRY)
        const resultado = `(${nomeDoGrupo}: ${nomesDosItens.join(', ')})`;
        console.log(`Resultado para ${nomeDoGrupo}:`, resultado);
        return resultado;
      }
      
      console.log(`Grupo ${nomeDoGrupo} vazio ou inválido`);
      return null;
    });

    // Junta todas as descrições válidas com um espaço.
    const resultado = descricoes.filter(d => d !== null).join(' ');
    console.log('Resultado final dos adicionais:', resultado);
    return resultado;
  }


  // Método auxiliar para renderizar o header da seção de local de entrega
  renderLocalEntregaHeader() {
    return (
      <header style={{ marginBottom: 20 }}>
        <h3 style={{ 
          fontSize: 20, 
          fontWeight: 700, 
          margin: 0, 
          color: '#333',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <span style={{
            width: '6px',
            height: '20px',
            background: 'linear-gradient(135deg, #007bff, #0056b3)',
            borderRadius: '3px'
          }}></span>
          📍 {this.state.retirada ? 'Local de Retirada' : 'Local da Entrega'}
        </h3>
      </header>
    );
  }

  // Método auxiliar para renderizar as informações do endereço
  renderInfoEndereco() {
    return (
      <div style={{
        background: this.state.retirada 
          ? 'linear-gradient(135deg, #e3f2fd, #bbdefb)' 
          : 'linear-gradient(135deg, #f8f9ff, #e3f2fd)',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '16px',
        border: this.state.retirada 
          ? '2px solid #2196f3'
          : '2px solid #1565c0',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
      }}>
        {/* Nome do local */}
        <div style={{ 
          fontSize: 18, 
          fontWeight: 700, 
          color: this.state.retirada ? '#0d47a1' : '#1565c0',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          {this.state.retirada ? '🏪' : '🏠'} {this.state.enderecoNome || 'Local não informado'}
        </div>

        {/* Informações do endereço */}
        {this.state.enderedoEnd ? (
          <div style={{
            background: '#fff',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '12px',
            border: '1px solid rgba(0,0,0,0.06)'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '6px'
            }}>
              {/* Endereço principal */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '14px',
                color: '#555'
              }}>
                <span style={{ fontWeight: '600' }}>📍</span>
                <span>
                  {this.state.enderedoEnd}
                  {this.state.enderedoNumero && this.state.enderedoNumero !== '0' ? `, ${this.state.enderedoNumero}` : ''}
                </span>
              </div>

              {/* Bairro */}
              {this.state.enderecoBairro && this.state.enderecoBairro !== 'Centro' ? (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '14px',
                  color: '#555'
                }}>
                  <span style={{ fontWeight: '600' }}>🏘️</span>
                  <span>{this.state.enderecoBairro}</span>
                </div>
              ) : null}

              {/* Taxa de entrega */}
              {!this.state.retirada && this.state.vlEntrega && parseFloat(this.state.vlEntrega) > 0 ? (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '14px',
                  color: '#28a745',
                  fontWeight: '600',
                  marginTop: '4px'
                }}>
                  <span>🚚</span>
                  <span>Taxa de entrega: € {this.mascaraValor(parseFloat(this.state.vlEntrega).toFixed(2))}</span>
                </div>
              ) : null}

              {/* Entrega gratuita */}
              {!this.state.retirada && (!this.state.vlEntrega || parseFloat(this.state.vlEntrega) === 0) ? (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '14px',
                  color: '#28a745',
                  fontWeight: '600',
                  marginTop: '4px'
                }}>
                  <span>🎉</span>
                  <span>Entrega Gratuita!</span>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}

        {/* Aviso de retirada */}
        {this.state.apenas_retirada ? (
          <div style={{
            background: 'linear-gradient(135deg, #dc3545, #c82333)',
            color: '#fff',
            padding: '12px 16px',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: 600,
            textAlign: 'center',
            boxShadow: '0 4px 12px rgba(220, 53, 69, 0.3)',
            marginTop: '8px'
          }}>
            ⚠️ HOJE, EXCEPCIONALMENTE, ESTAMOS RECEBENDO PEDIDOS PARA ESTE BAIRRO APENAS PARA "RETIRADA NO LOCAL"
          </div>
        ) : null}

        {/* Aviso quando não há endereço */}
        {!this.state.enderedoEnd ? (
          <div style={{
            background: 'linear-gradient(135deg, #fff3cd, #ffeaa7)',
            color: '#856404',
            padding: '12px 16px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: 600,
            textAlign: 'center',
            border: '1px solid #ffc107'
          }}>
            📍 Selecione um endereço para continuar
          </div>
        ) : null}
      </div>
    );
  }

  // Método auxiliar para renderizar os botões de endereço
  renderBotoesEndereco() {
    return (
      <div style={{ 
        display: 'flex', 
        gap: '16px', 
        justifyContent: 'space-between',
        flexWrap: 'wrap'
      }}>
        <button
          onClick={() => {
            this.props.history.push({
              pathname: '/Endereco',
              state: {
                quemChamou: 'Carrinho',
              }
            })
          }}
          style={{
            background: 'linear-gradient(135deg, #007bff, #0056b3)',
            color: '#fff',
            border: 'none',
            borderRadius: '10px',
            padding: '12px 20px',
            fontSize: '14px',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(0, 123, 255, 0.3)',
            flex: 1,
            minWidth: '140px'
          }}
          onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
        >
          📍 Mudar Endereço
        </button>

        {this.state.desativar_retirada ? (
          <div style={{
            background: '#6c757d',
            color: '#fff',
            borderRadius: '10px',
            padding: '12px 20px',
            fontSize: '14px',
            fontWeight: 600,
            flex: 1,
            minWidth: '140px',
            textAlign: 'center'
          }}>
            🏪 Retirada Desativada
          </div>
        ) : (
          <button
            onClick={() => {
              this.setState({
                listaEnd: true,
                apenas_retirada: false
              })
            }}
            style={{
              background: 'linear-gradient(135deg, #28a745, #20c997)',
              color: '#fff',
              border: 'none',
              borderRadius: '10px',
              padding: '12px 20px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(40, 167, 69, 0.3)',
              flex: 1,
              minWidth: '140px'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            🏪 Retirada no Local
          </button>
        )}
      </div>
    );
  }

  form() {
    const carrinho = (this.props.carr && Array.isArray(this.props.carr.carrinho)) ? this.props.carr.carrinho : [];
    this.vl = 0;
    this.vlAdc = 0;
    carrinho.forEach(i => {
      this.vl = parseFloat(this.vl) + parseFloat(i.preco || 0);
      // Não calcular adicional do cartão aqui - deixar sempre 0
      this.vlAdc = 0;
    });
    return (
      <div style={{ 
        minHeight: 'calc(100vh - 75px)', 
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        paddingBottom: '75px'
      }}>
        {/* Header Principal Moderno */}
        <header style={{ 
          background: 'linear-gradient(135deg, #991e25 0%, #b52d36 100%)',
          padding: '20px 24px',
          boxShadow: '0 4px 20px rgba(153, 30, 37, 0.3)',
          borderBottom: '3px solid rgba(255,255,255,0.1)',
          position: 'sticky',
          top: 0,
          zIndex: 1000
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            maxWidth: '1200px',
            margin: '0 auto'
          }}>
            <h1 style={{ 
              fontSize: 32, 
              fontWeight: 800, 
              margin: 0, 
              color: '#fff',
              letterSpacing: '0.5px',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}>
              🛒 Meu Carrinho
            </h1>
            <div style={{
              background: 'rgba(255,255,255,0.15)',
              padding: '6px 12px',
              borderRadius: '16px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              minWidth: 'fit-content',
              whiteSpace: 'nowrap'
            }}>
              <span style={{ 
                color: '#fff', 
                fontSize: 16, 
                fontWeight: 700,
                lineHeight: '1'
              }}>
                {carrinho.length}
              </span>
              <span style={{ 
                color: '#fff', 
                fontSize: 14, 
                fontWeight: 500,
                lineHeight: '1'
              }}>
                {carrinho.length === 1 ? 'item' : 'itens'}
              </span>
            </div>
          </div>
        </header>

        {/* Container Principal */}
        <main style={{ 
          maxWidth: '800px', 
          margin: '0 auto', 
          padding: '24px 20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '24px'
        }}>

          {/* Seção dos Itens do Carrinho */}
          <section style={{
            background: '#fff',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
            padding: '24px',
            border: '1px solid rgba(0,0,0,0.04)'
          }}>
            <header style={{ marginBottom: 20 }}>
              <h2 style={{ 
                fontSize: 24, 
                fontWeight: 700, 
                margin: 0, 
                color: '#333',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <span style={{
                  width: '6px',
                  height: '24px',
                  background: 'linear-gradient(135deg, #991e25, #b52d36)',
                  borderRadius: '3px'
                }}></span>
                📦 Itens do Carrinho
              </h2>
            </header>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {carrinho.map((i, d) => (
                <ListCarrinho 
                  key={d}
                  qtd={i.quant} 
                  nome={i.nome} 
                  preco={i.preco} 
                  pos={d} 
                  adcionais={this.retornaAdc(d)} 
                />
              ))}
            </div>
          </section>

          {/* Seção do Cupom de Desconto */}
          <section style={{
            background: '#fff',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
            padding: '24px',
            border: '1px solid rgba(0,0,0,0.04)'
          }}>
            <header style={{ marginBottom: 18 }}>
              <h3 style={{ 
                fontSize: 20, 
                fontWeight: 700, 
                margin: 0, 
                color: '#333',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <span style={{
                  width: '6px',
                  height: '20px',
                  background: 'linear-gradient(135deg, #28a745, #20c997)',
                  borderRadius: '3px'
                }}></span>
                🎫 Cupom de Desconto
              </h3>
            </header>
            <div style={{ 
              display: 'flex', 
              gap: '12px', 
              alignItems: 'flex-end' 
            }}>
              <div style={{ flex: 1 }}>
                <Input
                  placeholder="Digite seu cupom de desconto"
                  value={this.state.cupom}
                  disabled={this.state.isCupom}
                  name="cupom"
                  onChange={this.handleChange}
                  style={{ 
                    width: "100%",
                    padding: '12px 16px',
                    fontSize: '16px',
                    border: '2px solid #e9ecef',
                    borderRadius: '12px',
                    transition: 'all 0.3s ease',
                    backgroundColor: this.state.isCupom ? '#f8f9fa' : '#fff'
                  }}
                />
              </div>
              {!this.state.isCupom && (
                <button
                  onClick={this.handleCupom}
                  style={{
                    background: 'linear-gradient(135deg, #28a745, #20c997)',
                    border: 'none',
                    borderRadius: '12px',
                    padding: '12px 16px',
                    color: '#fff',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: '50px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 12px rgba(40, 167, 69, 0.3)'
                  }}
                  onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                  onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  <CheckIcon style={{ fontSize: 20 }} />
                </button>
              )}
            </div>
          </section>

        {/* <div style={{ marginLeft: 21, marginTop: 20, paddingRight: 20, }}>
          <div style={{ marginBottom: 0, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <label style={{ fontWeight: "bold", }}>Cartão fidelidade ( {this.state.fidel} / 10)</label>
          </div>
          <div style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 20 }}>
            <Icon type='AntDesign' name={this.state.fidel >= 1 ? 'checkcircle' : 'closecircle'} style={{ fontSize: 18, color: this.state.fidel >= 1 ? 'green' : '#D3D3D3' }} />
            <Icon type='AntDesign' name={this.state.fidel >= 2 ? 'checkcircle' : 'closecircle'} style={{ fontSize: 18, color: this.state.fidel >= 2 ? 'green' : '#D3D3D3' }} />
            <Icon type='AntDesign' name={this.state.fidel >= 3 ? 'checkcircle' : 'closecircle'} style={{ fontSize: 18, color: this.state.fidel >= 3 ? 'green' : '#D3D3D3' }} />
            <Icon type='AntDesign' name={this.state.fidel >= 4 ? 'checkcircle' : 'closecircle'} style={{ fontSize: 18, color: this.state.fidel >= 4 ? 'green' : '#D3D3D3' }} />
            <Icon type='AntDesign' name={this.state.fidel >= 5 ? 'checkcircle' : 'closecircle'} style={{ fontSize: 18, color: this.state.fidel >= 5 ? 'green' : '#D3D3D3' }} />
            <Icon type='AntDesign' name={this.state.fidel >= 6 ? 'checkcircle' : 'closecircle'} style={{ fontSize: 18, color: this.state.fidel >= 6 ? 'green' : '#D3D3D3' }} />
            <Icon type='AntDesign' name={this.state.fidel >= 7 ? 'checkcircle' : 'closecircle'} style={{ fontSize: 18, color: this.state.fidel >= 7 ? 'green' : '#D3D3D3' }} />
            <Icon type='AntDesign' name={this.state.fidel >= 8 ? 'checkcircle' : 'closecircle'} style={{ fontSize: 18, color: this.state.fidel >= 8 ? 'green' : '#D3D3D3' }} />
            <Icon type='AntDesign' name={this.state.fidel >= 9 ? 'checkcircle' : 'closecircle'} style={{ fontSize: 18, color: this.state.fidel >= 9 ? 'green' : '#D3D3D3' }} />
          </div>
        </div> */}

          {/* Seção de Endereço/Local - Reconstruída */}
          <section style={{
            background: '#fff',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
            padding: '24px',
            border: '1px solid rgba(0,0,0,0.04)'
          }}>
            {this.renderLocalEntregaHeader()}
            {this.renderInfoEndereco()}
            {this.renderBotoesEndereco()}
          </section>
          
          {/* Seção de Forma de Pagamento */}
          <section style={{
            background: '#fff',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
            padding: '24px',
            border: '1px solid rgba(0,0,0,0.04)'
          }}>
            <header style={{ marginBottom: 20 }}>
              <h3 style={{ 
                fontSize: 20, 
                fontWeight: 700, 
                margin: 0, 
                color: '#991e25',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <span style={{
                  width: '6px',
                  height: '20px',
                  background: 'linear-gradient(135deg, #991e25, #b52d36)',
                  borderRadius: '3px'
                }}></span>
                💳 Como Deseja Pagar?
              </h3>
              <p style={{ 
                color: '#666', 
                fontSize: 14, 
                margin: '8px 0 0 18px',
                fontStyle: 'italic'
              }}>
                Selecione sua forma de pagamento preferida
              </p>
            </header>

            <div style={{ marginBottom: '20px' }}>
              <Select
                id="demo-simple-select"
                value={this.state.pagamento}
                onChange={this.handleChange}
                name="pagamento"
                style={{ 
                  width: '100%',
                  borderRadius: '12px',
                  border: '2px solid #e9ecef',
                  fontSize: '16px'
                }}
                displayEmpty
              >
                <MenuItem value="Escolha">
                  <em style={{ color: '#999' }}>Escolha uma forma de pagamento</em>
                </MenuItem>
                <MenuItem value="Dinheiro">
                  💵 Dinheiro
                </MenuItem>
                <MenuItem value="Cartao">
                  💳 Cartão Crédito/Débito
                </MenuItem>
                <MenuItem value="MBway">
                  📱 MBway
                </MenuItem>
              </Select>
            </div>

            {/* Seção específica para Dinheiro */}
            {this.state.pagamento === "Dinheiro" && (
              <div style={{
                background: 'linear-gradient(135deg, #fff3cd, #ffeaa7)',
                borderRadius: '12px',
                padding: '20px',
                border: '2px solid #ffc107'
              }}>
                <h4 style={{ 
                  margin: '0 0 12px 0', 
                  color: '#856404',
                  fontSize: '16px',
                  fontWeight: 600
                }}>
                  💰 Troco para quanto?
                </h4>
                <Input
                  placeholder="Ex: € 50,00"
                  value={this.state.vlTroco}
                  name="vlTroco"
                  onChange={this.handleMoneyChange}
                  style={{
                    width: "100%",
                    padding: '12px 16px',
                    fontSize: '16px',
                    border: '2px solid #ffc107',
                    borderRadius: '8px',
                    backgroundColor: '#fff'
                  }}
                />
              </div>
            )}

            {/* Seção específica para MBway */}
            {this.state.pagamento === "MBway" && (
              <div style={{
                background: 'linear-gradient(135deg, #e3f2fd, #bbdefb)',
                borderRadius: '12px',
                padding: '20px',
                border: '2px solid #2196f3'
              }}>
                <h4 style={{ 
                  margin: '0 0 12px 0', 
                  color: '#0d47a1',
                  fontSize: '16px',
                  fontWeight: 600
                }}>
                  📱 Informações do MBway
                </h4>
                <div style={{
                  background: '#fff',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '12px',
                  border: '1px solid #90caf9'
                }}>
                  <strong>Chave MBway:</strong><br/>
                  938039957<br/>
                  <strong>Favorecido:</strong><br/>
                  Thallyta de Sousa Melo<br/>
                  <strong>Banco:</strong><br/>
                  Novo Banco PT
                </div>
                <div style={{
                  background: '#fff3e0',
                  borderRadius: '8px',
                  padding: '16px',
                  border: '2px solid #ff9800',
                  marginBottom: '12px'
                }}>
                  <div style={{ 
                    fontSize: '16px', 
                    fontWeight: 'bold', 
                    color: '#e65100',
                    marginBottom: '8px',
                    textAlign: 'center'
                  }}>
                    🚨 ATENÇÃO: PASSO A PASSO OBRIGATÓRIO
                  </div>
                  <div style={{ color: '#bf360c', fontSize: '14px', lineHeight: '1.4' }}>
                    <div style={{ marginBottom: '8px' }}>
                      <strong>1️⃣</strong> Primeiro clique no botão <strong>"FINALIZAR PEDIDO"</strong> (botão verde abaixo)
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <strong>2️⃣</strong> Depois faça o pagamento MBway com os dados acima
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <strong>3️⃣</strong> Por último, envie o comprovante pelo WhatsApp
                    </div>
                    <div style={{ 
                      background: '#ffebee', 
                      padding: '8px', 
                      borderRadius: '6px',
                      marginTop: '12px',
                      textAlign: 'center',
                      fontWeight: 'bold'
                    }}>
                      ⚠️ Seu pedido só entrará em preparo após completar TODOS os passos!
                    </div>
                  </div>
                </div>
              </div>
            )}
          </section>

          {/* Resumo da Conta */}
          <section style={{
            background: 'linear-gradient(135deg, #f8f9ff, #e3f2fd)',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
            padding: '24px',
            margin: '20px',
            border: '1px solid #e1f5fe'
          }}>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 700,
              color: '#1565c0',
              margin: '0 0 20px 0',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              📊 Resumo da Conta
            </h3>

            <div style={{
              background: '#fff',
              borderRadius: '12px',
              padding: '20px',
              boxShadow: '0 4px 16px rgba(0,0,0,0.04)'
            }}>
              {/* Itens do resumo */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px 0',
                borderBottom: '1px solid #f0f0f0'
              }}>
                <span style={{ fontSize: '14px', color: '#666' }}>🛍️ Total dos itens</span>
                <span style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>
                  € {this.mascaraValor(eval(parseFloat(this.vl)).toFixed(2))}
                </span>
              </div>

              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px 0',
                borderBottom: '1px solid #f0f0f0'
              }}>
                <span style={{ fontSize: '14px', color: '#666' }}>🚚 Taxa de entrega</span>
                <span style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>
                  € {this.mascaraValor(eval(parseFloat(this.state.vlEntrega)).toFixed(2))}
                </span>
              </div>

              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px 0',
                borderBottom: '1px solid #f0f0f0'
              }}>
                <span style={{ fontSize: '14px', color: '#666' }}>🎯 Descontos</span>
                <span style={{ fontSize: '16px', fontWeight: '600', color: '#4caf50' }}>
                  - € {this.mascaraValor(eval(parseFloat(this.state.vlCupom)).toFixed(2))}
                </span>
              </div>

              {this.state.pagamento === 'Cartao' && (
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0'
                }}>
                  <span style={{ fontSize: '14px', color: '#666' }}>💳 Taxa do cartão</span>
                  <span style={{ fontSize: '16px', fontWeight: '600', color: '#ff9800' }}>
                    + € {this.mascaraValor(eval(parseFloat(this.vlAdc)).toFixed(2))}
                  </span>
                </div>
              )}

              {/* Total final */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '20px 0 0 0',
                marginTop: '16px',
                borderTop: '2px solid #1565c0',
                flexWrap: 'wrap',
                gap: '12px'
              }}>
                <div style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '18px', 
                  fontWeight: '700', 
                  color: '#1565c0',
                  minWidth: 'fit-content'
                }}>
                  <span>💰</span>
                  <span>Total Final</span>
                </div>
                <div style={{ 
                  fontSize: '22px', 
                  fontWeight: '700', 
                  color: '#1565c0',
                  background: 'linear-gradient(135deg, #bbdefb, #e3f2fd)',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  minWidth: 'fit-content',
                  whiteSpace: 'nowrap'
                }}>
                  € {this.mascaraValor(eval((parseFloat(this.vl) + parseFloat(this.state.vlEntrega) + (this.state.pagamento === 'Cartao' ? parseFloat(this.vlAdc) : parseFloat(0))) - parseFloat(this.state.vlCupom)).toFixed(2))}
                </div>
              </div>
            </div>
          </section>

          {/* Botão de Finalizar */}
          <div 
            className="botao-finalizar-container"
            style={{ 
              padding: '20px', 
              paddingBottom: window.innerWidth <= 768 ? '80px' : '40px' 
            }}
          >
            <Button 
              variant="contained" 
              style={{
                width: '100%',
                height: '60px',
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #4caf50, #66bb6a)',
                boxShadow: '0 8px 24px rgba(76, 175, 80, 0.3)',
                fontSize: '18px',
                fontWeight: '700',
                textTransform: 'none',
                border: 'none',
                color: '#fff',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 12px 32px rgba(76, 175, 80, 0.4)'
                }
              }}
              onClick={() => {
                if (this.state.ativo) {
                  if (this.state.enderedoEnd !== '') {
                    if (!this.state.apenas_retirada) {
                      this.setState({ open: true })
                    } else {
                      alert('Hoje, excepcionalmente, estamos recebendo pedidos para este bairro apenas para "retirada no local", amanhã voltaremos com entrega, muito obrigado!', 'Atenção', false);
                    }
                  } else {
                    alert('Informe o endereço de entrega!', 'Atenção', false);
                  }
                } else {
                  alert('Estamos fechado', 'Atenção', false);
                }
              }}
            >
              🛒 Finalizar Pedido
            </Button>
          </div>

          {/* Modal para lista de endereços */}
          <Modal
            onHide={() => this.setState({ listaEnd: false })}
            className="modal-end"
            show={this.state.listaEnd}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>Escolha um local para retirada</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ul className="lista-endereços">{this.state.enderecosEmpresa.map(e => <li
                onClick={() => this.handleEndereco(e)}
              >
                <h4>{e.nome}</h4>
                {e.endereco.split(`\\r\\n`).map(p => <h6>
                  {p}
                </h6>)}
              </li>)}</ul>
            </Modal.Body>
          </Modal>

          {/* Dialog de confirmação */}
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Verificação"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {"Finalizar seu pedido? "}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => { this.setState({ open: false }); }} color="primary">
                Cancelar
              </Button>
              <Button onClick={async () => {
                if (this.vl < this.state.vlMinimo) {
                  alert(`Valor mínimo do pedido é de € ${parseFloat(this.state.vlMinimo).toFixed(2).replace('.', ',')}`);
                } else {
                  var Valid = 0;
                  if (this.state.pagamento === "Dinheiro") {
                    if (this.state.vlTroco == 0) {
                      Valid = 1
                    } else {
                      var aa = parseFloat(this.state.vlTroco);
                      var bb = ((parseFloat(this.vl) + parseFloat(this.state.vlEntrega)) - parseFloat(this.state.vlCupom))

                      if (aa < bb) {
                        Valid = 0
                      } else {
                        Valid = 1
                      }
                    }
                  } else {
                    Valid = 1
                  }
                  if (Valid === 0) {
                    alert("Valor do troco menor que o total do pedido.", 'Atenção', false)
                  } else {
                    this.handlleEnviarPedido()
                  }
                }
                this.setState({ open: false });
              }} color="primary" autoFocus>
                Ok
              </Button>
            </DialogActions>
          </Dialog>

        </main>
      </div >
    );
  }

  mascaraValor(valor) {
    valor = valor.toString().replace(/\D/g, "");
    valor = valor.toString().replace(/(\d)(\d{8})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{5})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{2})$/, "$1,$2");
    return valor
  }

  onValueChange(value) {
    this.setState({
      pagamento: value
    });
  }

  // onValueChange2(value) {
  //   value === 'Sim' ? this.setState({ obs: '' }) : null
  //   this.setState({
  //     nf: value
  //   });
  // }

  render() {
    const carrinho = (this.props.carr && Array.isArray(this.props.carr.carrinho)) ? this.props.carr.carrinho : [];
    return (carrinho.length > 0 ? (this.state.isLoading ? <Carregando /> : this.form()) : this.vazio());
  }

  vazio() {
    return (
      <div style={{ 
        minHeight: 'calc(100vh - 75px)', 
        background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '75px'
      }}>
        {/* Header */}
        <div style={{ 
          flexDirection: 'row', 
          justifyContent: 'space-between', 
          paddingTop: 5, 
          paddingLeft: 5, 
          paddingRight: 15,
          background: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: '0 0 16px 16px',
          marginBottom: 20
        }}>
          <div>
            <label style={{ 
              fontSize: 28, 
              fontWeight: "bold", 
              marginLeft: 15, 
              marginTop: 15,
              color: '#333'
            }}>
              Carrinho
            </label>
          </div>
        </div>
        
        {/* Conteúdo principal do carrinho vazio */}
        <div style={{ 
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
          textAlign: 'center'
        }}>
          {/* Ícone do carrinho */}
          <div 
            className="carrinho-vazio-icon"
            style={{
              width: 120,
              height: 120,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 32,
              boxShadow: '0 8px 32px rgba(33, 150, 243, 0.2)',
              border: '3px solid rgba(33, 150, 243, 0.1)'
            }}
          >
            <svg 
              width="60" 
              height="60" 
              fill="none" 
              stroke="#2196f3" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              viewBox="0 0 24 24"
            >
              <circle cx="9" cy="21" r="1"/>
              <circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
          </div>
          
          {/* Título */}
          <h2 
            className="carrinho-vazio-title"
            style={{
              fontSize: 28,
              fontWeight: 'bold',
              color: '#333',
              margin: '0 0 16px 0',
              letterSpacing: '0.5px'
            }}
          >
            Seu carrinho está vazio
          </h2>
          
          {/* Subtítulo */}
          <p 
            className="carrinho-vazio-subtitle"
            style={{
              fontSize: 16,
              color: '#666',
              lineHeight: 1.5,
              margin: '0 0 40px 0',
              maxWidth: 300
            }}
          >
            Adicione produtos deliciosos ao seu carrinho e faça seu pedido!
          </p>
          
          {/* Botão para voltar ao cardápio */}
          <button
            className="carrinho-vazio-btn"
            style={{
              background: 'linear-gradient(135deg, #991e25 0%, #b71c1c 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: 50,
              padding: '16px 32px',
              fontSize: 16,
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 8px 24px rgba(153, 30, 37, 0.3)',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              textTransform: 'none',
              letterSpacing: '0.5px'
            }}
            onClick={() => {
              const { setCurrentTab } = this.props;
              setCurrentTab(0); // Volta para a aba inicial/home
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 12px 32px rgba(153, 30, 37, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 24px rgba(153, 30, 37, 0.3)';
            }}
          >
            <svg 
              width="20" 
              height="20" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              viewBox="0 0 24 24"
            >
              <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17M17 13v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-6.28"/>
            </svg>
            Ver Cardápio
          </button>
          
          {/* Decoração adicional */}
          <div style={{
            position: 'absolute',
            top: '20%',
            right: '10%',
            width: 60,
            height: 60,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #fff3e0 0%, #ffcc02 100%)',
            opacity: 0.3,
            animation: 'float 3s ease-in-out infinite'
          }} />
          
          <div style={{
            position: 'absolute',
            bottom: '30%',
            left: '15%',
            width: 40,
            height: 40,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #ffebee 0%, #f44336 100%)',
            opacity: 0.3,
            animation: 'float 2s ease-in-out infinite reverse'
          }} />
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            
            @media (max-width: 480px) {
              .carrinho-vazio-btn {
                padding: 14px 24px !important;
                font-size: 15px !important;
              }
              .carrinho-vazio-title {
                font-size: 24px !important;
              }
              .carrinho-vazio-subtitle {
                font-size: 15px !important;
              }
              .carrinho-vazio-icon {
                width: 100px !important;
                height: 100px !important;
              }
              .carrinho-vazio-icon svg {
                width: 50px !important;
                height: 50px !important;
              }
            }
          `}</style>
        </div>
      </div>
    );
  }

  mdFinal() {
    return (<div></div>
      // <Modal
      //   animationType="fade"
      //   transparent={true}
      //   visible={this.state.isMoto}
      //   onRequestClose={() => {
      //     this.setState({ isMoto: false })
      //   }}>
      //   <div style={{ flex: 1, marginTop: 0, backgroundColor: 'rgba(0, 0, 0, 0.2)', }}>
      //     <div style={{ flex: 1, marginTop: 100, backgroundColor: '#ffffff', borderTopRightRadius: 0, borderTopLeftRadius: 0 }}>
      //       <div style={{ marginTop: 10, marginLeft: 25 }}>
      //         <TouchableOpacity style={{ height: 40, width: 40 }} onPress={() => { this.setState({ isMoto: false }) }}>
      //           <Icon name="close" />
      //         </TouchableOpacity>
      //       </div>
      //       <Scrolldiv>
      //         <div><label style={{ fontSize: 12, fontWeight: 'bold', marginLeft: 15, marginBottom: 15 }}>Informações finais</label></div>

      //         <ListItem>
      //           <CheckBox checked={this.state.isAgend} onPress={() => { this.setState({ isAgend: !this.state.isAgend }) }} />
      //           <Body>
      //             <label>Agendar entrega?</label>
      //           </Body>
      //         </ListItem>
      //         <div style={{ width: '100%', marginTop: 15, paddingLeft: 15, paddingRight: 15 }}>
      //           {this.state.isAgend ? <div>
      //             <div style={{ marginTop: 5, width: '100%', marginLeft: 10 }}>
      //               <DatePicker
      //                 style={{ width: 200 }}
      //                 date={this.state.date}
      //                 format="DD/MM/YYYY"
      //                 minDate={new Date().getDay() + "/" + new Date().getMonth() + "/" + new Date().getFullYear()}
      //                 maxDate="31-08-2025"
      //                 onDateChange={this.selectDate}
      //                 style={{ width: '100%' }}
      //               />
      //             </div>


      //             <div style={{ marginTop: 10, width: '100%', marginLeft: 10, flexDirection: 'row' }}>
      //               <label style={{
      //                 width: '87%',
      //                 labelAlign: 'center',
      //                 padding: 10,
      //                 borderColor: '#cccccc',
      //                 borderWidth: 1.3
      //               }} onPress={() => this.TimePicker.open()}>{this.state.time}</label>
      //               <TimePicker
      //                 ref={ref => {
      //                   this.TimePicker = ref;
      //                 }}
      //                 labelCancel="Cancelar"
      //                 labelConfirm="Gravar"
      //                 selectedHour={new Date().getHours() + ""}
      //                 selectedMinute={new Date().getMinutes() + ""}
      //                 onCancel={() => this.onCancel()}
      //                 onConfirm={(hour, minute) => this.onConfirm(hour, minute)}
      //               />
      //               <TouchableOpacity style={{ width: 30, marginLeft: 10, marginTop: 5 }} iconLeft onPress={() => this.TimePicker.open()}>
      //                 <Icon type="Ionicons" name="md-time" style={{ color: "#000" }} />
      //               </TouchableOpacity>

      //             </div>
      //           </div> : null}

      //         </div>

      //         {this.state.pagamento === 'Dinheiro' ?
      //           <ListItem>
      //             <CheckBox checked={this.state.isToco} onPress={() => { this.setState({ isToco: !this.state.isToco }) }} />
      //             <Body>
      //               <label>Deseja troco?</label>
      //             </Body>
      //           </ListItem> : null
      //         }

      //         <div style={{ width: '100%', marginTop: 15, paddingLeft: 15, paddingRight: 15 }}>
      //           {this.state.isToco ? <div>
      //             <div style={{ marginTop: 20, width: '100%' }}>
      //               <div style={{ marginBottom: 0, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      //                 <label style={{ fontWeight: "bold", }}>Valor para troco: </label>
      //               </div>
      //               <div>
      //                 <div style={{ marginTop: 15, }}>
      //                   <Item>
      //                     <Input
      //                       value={this.state.vlTroco}
      //                       onChangelabel={vlTroco => this.setState({ vlTroco })}
      //                     />
      //                   </Item>
      //                 </div>
      //               </div>
      //             </div>
      //           </div> : null}
      //         </div>

      //         <ListItem>
      //           <CheckBox checked={this.state.isFisc} onPress={() => { this.setState({ isFisc: !this.state.isFisc }) }} />
      //           <Body>
      //             <label>Nota Fiscal?</label>
      //           </Body>
      //         </ListItem>
      //         <div style={{ width: '100%', marginTop: 15, paddingLeft: 15, paddingRight: 15 }}>
      //           {this.state.isFisc ? <div>
      //             <div style={{ marginTop: 20, width: '100%' }}>
      //               <div style={{ marginBottom: 0, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      //                 <label style={{ fontWeight: "bold", }}>CPF ou CNPJ na nota: </label>
      //               </div>
      //               <div>
      //                 <div style={{ marginTop: 15, }}>
      //                   <Item>
      //                     <Input
      //                       value={this.state.notaFiscal}
      //                       onChangelabel={notaFiscal => this.setState({ notaFiscal })}
      //                     />
      //                   </Item>
      //                 </div>
      //               </div>
      //             </div>
      //           </div> : null}
      //         </div>

      //         <div style={{ width: '100%', alignItems: 'center' }}>
      //           <div style={{ width: '100%', marginTop: 15, paddingLeft: 15, paddingRight: 15 }}>
      //             <div style={{ marginBottom: 0, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>

      //             </div>


      //             <div style={{ marginTop: 20, }}>
      //               <Button full success onPress={() => {
      //                 this.handlleEnviarPedido()
      //               }}>
      //                 <label>Finalizar pedido</label>
      //               </Button>
      //             </div>
      //           </div>
      //         </div>
      //       </Scrolldiv>
      //     </div>
      //   </div>
      // </Modal >
    );
  }

  onCancel() {
    this.TimePicker.close();
  }

  onConfirm(hour, minute) {
    this.setState({ time: `${hour}:${minute}`, obs: " Entregar as: " + `${hour}:${minute}` });
    this.TimePicker.close();
  }

  selectDate = (date) => {
    this.setState({ date: date });
  }
}

const mapStateToProps = state => ({
  carr: state.CarrinhoReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setCar, setCarEmp, setCurrentTab }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Carrinho);
